import * as React from "react";
import { forwardRef } from "react";
const SvgAdd = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9 0a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9m0 1.385A7.615 7.615 0 1 1 1.385 9 7.606 7.606 0 0 1 9 1.385m-.692 3.462v3.462H4.846v1.385h3.462v3.462h1.385V9.692h3.462V8.308H9.692V4.846Z", className: "s895ead2ae021fbeeac51b5b6eb2bc9dc__b" }));
const ForwardRef = forwardRef(SvgAdd);
export { ForwardRef as ReactComponent };
